import React, { useContext, useRef, useState } from 'react'
import './Navbar.css'
import logo1 from '../Assets/logo1.png'
import cart_icon from '../Assets/cart_icon.png'
import { Link } from 'react-router-dom'
import { ShopContext } from '../../Context/ShopContext'
import  nav_dropdown from '../Assets/drop-down-list.png'


const Navbar = () => {



    const [menu, setMenu] = useState("shop");
    const {getTotalCartItems}=useContext(ShopContext);
   const menuRef= useRef();
   const dropdown_toggle=(e)=>{
menuRef.current.classList.toggle('nav-menu-visible');
   e.target.classList.toggle('open');}
   
   const handleFeaturedClick=()=>{
       window.open('https://docs.google.com/forms/d/e/1FAIpQLSeGbMswRCfVGVnVxUS9TDdzgX384UlkEeDo1ppNJ5wsZUhsdw/viewform', '_blank');
   }
   
    return (
        <div className='navbar'>
            <div className="nav-logo">
                <img src={logo1} alt="" />
                <p>SARATHI</p>
            </div>

           <img className='nav-dropdown' onClick={dropdown_toggle} src={nav_dropdown} alt =""/>
            <ul ref={menuRef} className="nav-menu">
                <li onClick={() => { setMenu("shop") }}><Link style={{ textDecoration:'none',color: '#617978'}} to='/'>Shop</Link>{menu === "shop" ? <hr /> : <></>}</li>
                <li onClick={() => { setMenu("Arts") }}><Link style={{textDecoration:'none',color: '#617978'}}to='./Arts'>Arts & Digital Arts</Link>{menu === "Arts" ? <hr /> : <></>}</li>
                <li onClick={() => { setMenu("HandiCrafts") }}><Link style={{textDecoration:'none',color: '#617978'}}to ='./HandiCrafts'>HandiCrafts</Link>{menu === "HandiCrafts" ? <hr /> : <></>}</li>
                <li onClick={() => { setMenu("Plants") }}><Link style={{textDecoration:'none',color: '#617978'}}to='./Plants'>Plants</Link>{menu === "Plants" ? <hr /> : <></>}</li>
                 <button className="nav-featured-btn" onClick={handleFeaturedClick}>Want your products to be here?</button>
            </ul>
           
            <div className="nav-login-cart">
                
                {localStorage.getItem('auth-token')?<button onClick={()=>{localStorage.removeItem('auth-token');window.location.replace('/')}}>Logout</button>
                : <Link style={{textDecoration:'none',color: '#617978'}}to='./login'><button>Login</button></Link> }

              
                <Link style={{textDecoration:'none',color: '#617978'}}to={'./cart'}><img src={cart_icon} alt="" /></Link>
                <div className="nav-cart-count">{getTotalCartItems()}</div>
            </div>
        </div>
    )
}

export default Navbar
